var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('h1',{staticClass:"title-pages"},[_vm._v(_vm._s(_vm.title))])]),_c('b-col',{attrs:{"cols":"auto"}},[_vm._t("top-right-button")],2)],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }